import { useOverview } from "@/lib/api";
import ScheduleList from "@/components/ScheduleList";

export default function SchedulePage() {
  const { data, isLoading } = useOverview();
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12">
      <p className="label-cap">What's happening</p>
      <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-amber-950 mt-2 mb-10">Schedule</h1>
      {isLoading ? <p className="text-lg">Loading…</p> : <ScheduleList items={data?.schedule || []} />}
    </div>
  );
}
